import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What is a Float?",
    a: (
      <>
        <p>
          A Float is GigAfloat&apos;s term for temporary access to funds based on verified earnings. Floats are designed to help bridge the gap between completed work and platform payouts.
        </p>
        <p>
          Unlike traditional lending products, GigAfloat is built around real earnings activity. If approved, a Float provides access to funds before your next platform payout, with repayment designed around future earnings.
        </p>
        <ul className="space-y-1.5 pt-1 font-mono-c text-[12px] uppercase tracking-[0.18em] text-[#00FF88]">
          <li>· Work completed.</li>
          <li>· Earnings verified.</li>
          <li>· Float sent upon approval.</li>
        </ul>
      </>
    ),
  },
  {
    q: "Is GigAfloat a loan?",
    a: (
      <>
        <p>
          GigAfloat is designed differently from traditional lending products. Floats are based on verified earnings activity rather than traditional credit scores or payroll deposits and are designed to help bridge the gap between completed work and platform payouts.
        </p>
        <p className="text-[#00FF88] font-semibold">
          No interest. Transparent fees. Built for gig workers.
        </p>
      </>
    ),
  },
  {
    q: "Which gig platforms are supported?",
    a: "6+ at launch: DoorDash, Uber, Lyft, Instacart, Spark, and Roadie. More gig platforms dropping every month — request yours in-app.",
  },
  {
    q: "How fast can I get a Float?",
    a: "Under 60 seconds, end-to-end. Once your gig platforms are connected we verify your earning activity instantly. Floats hit your debit card, gig worker card, or digital wallet — whichever you already use to receive platform payouts.",
  },
  {
    q: "What does it cost?",
    a: (
      <>
        <p><strong className="text-white">Built to be transparent.</strong></p>
        <p>No interest. No predatory pricing.</p>
        <p>Simple membership options. Transparent Float fees.</p>
        <p>
          Each approved Float includes a flat fee based on the Float amount, and your total repayment amount is always disclosed before acceptance.
        </p>
        <p className="text-white/55">
          If a Float is not repaid on time, additional Floats may not be available until repayment is resolved.
        </p>
      </>
    ),
  },
  {
    q: "Is my data safe?",
    a: "Bank-grade 256-bit encryption, read-only platform access, SOC 2 in progress. We never sell your data. Disconnect any platform in one tap.",
  },
];

const FAQ = () => (
  <section id="faq" className="py-24 md:py-32 border-t border-white/5" data-testid="faq-section">
    <div className="max-w-[900px] mx-auto px-6 lg:px-12">
      <div className="font-mono-c text-[10px] uppercase tracking-[0.25em] text-[#00FF88] mb-4 text-center">
        // FAQ
      </div>
      <h2 className="text-center font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter mb-14">
        Real talk, <span className="text-white/40">no fine print.</span>
      </h2>

      <Accordion type="single" collapsible className="space-y-3">
        {faqs.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            className="glass rounded-2xl border border-white/5 px-6 data-[state=open]:border-[#00FF88]/30 transition-colors"
            data-testid={`faq-item-${i}`}
          >
            <AccordionTrigger className="text-left font-display font-bold text-lg hover:no-underline py-5">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-white/65 text-base leading-relaxed pb-5 space-y-3">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FAQ;
